import React from "react";
import "../Gallery/Gallery.css";
const Gallery = () => {
  const html = document.querySelector("html");
  html.setAttribute("data-bs-theme", "dark");
  return (
    <>
      <div>
        <h1 className="text-center mb-0 head-g">Our Gallery</h1>

        <section className="hover-gallery">
          <div className="container-fluid gallery-container">
            <div className="gallery-wrap">
              <div
                className="item item-1"
                style={{ backgroundImage: 'url("g1.webp")' }}
              ></div>
              <div
                className="item item-2"
                style={{ backgroundImage: 'url("g2.webp")' }}
              ></div>

              <div
                className="item item-3"
                style={{ backgroundImage: 'url("t.webp")' }}
              ></div>
              <div
                className="item item-4"
                style={{ backgroundImage: 'url("g3.webp")' }}
              ></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Gallery;
